import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import PATHS, { url } from "src/consts/urlPaths";

type SlidesLinkProps = {
  children?: ReactNode;
  item?: { name?: string };
  className?: string;
};

const SlidesLink = ({ children, item, className }: SlidesLinkProps) => (
  <Link
    id="slides-nav-link"
    to={url(PATHS.SLIDES)}
    aria-label={item?.name}
    className={className}
  >
    {children}
  </Link>
);

export default SlidesLink;
